
import { useAuth } from "@/app/providers/AuthContext";
import { qk } from "@/shared/api/keys";
import { supabase } from "@/shared/api/supabaseClient";
import { useSupabaseQuery } from "@/shared/api/useSupabaseQuery";

import type { Practice } from "./practice.types";

const fetchPracticeDetails = async (): Promise<Practice> => {
  const { data, error } = await supabase
    .from("practices")
    .select("*")
    .single();

  if (error) throw error;
  if (!data) throw new Error("Practice not found");

  return data;
};

export const usePracticeDetails = () => {
  const { activePracticeId } = useAuth();

  return useSupabaseQuery(
    qk.detail("practices", "current"),
    fetchPracticeDetails,
    {
      namespaces: ["practice", "ui"],
      enabled: !!activePracticeId,
      staleTime: 1000 * 60 * 5, // 5 minutes
    }
  );
};